<div class="documentBox">
  <!-- Selection -->
  <mat-card class="filter selection" *ngIf="selectedFileArray.length!=0">
    <div class="sortview">
      Items Selected <span class="count">{{ selectedFileArray.length }}</span>
    </div>
   
    <div class="selectact">
      <button mat-button color="primary"  title="Only selected document will be send to PointClickCare"
        (click)="GetDocumentCategory(documentCategory)"
        *ngIf="(selectedFileArray.length==1 || this.totalCount <= this.docLimit) && ShowPointClickCare==true">
        <img  style="height: 22px;margin-right: 6px;"
        class="payCheckIcon"
        src="../../../../assets/icons/pccfavicon-32x32.png"
      />Upload
      </button>
      <!-- <button [disabled]="!showPCC"  mat-icon-button matTooltip="Send to PointClickCare">
        <img (click)="SendtoPendingPatientPCC()" style="height: 22px;margin-top: -10px;"
        class="payCheckIcon"
        src="../../../../assets/icons/pccfavicon-32x32.png"
      />
          </button> -->

        <button mat-button color="primary" *ngIf="ShowRequestButton" (click)="shareOnPortal()">
            <mat-icon>assignment</mat-icon> Share On Portal
        </button>

      <button mat-button color="primary" title="Only selected document will be send to fax"
        (click)="FaxFiles(shareFile)" *ngIf="ShowRequestButton">
        <mat-icon>assignment</mat-icon> Fax
      </button>
      <button mat-button color="primary" (click)="RequestFiles(shareFile)" *ngIf="ShowRequestButton">
        <mat-icon>assignment</mat-icon> Request
      </button>
      <ng-container *ngIf="showLocalPanel">
        <button mat-button color="primary">
          <mat-icon>share</mat-icon> Email
        </button>
        <button mat-button color="primary">
          <mat-icon>print</mat-icon> Fax
        </button>
      </ng-container>

      <button mat-button color="primary" *ngIf="ShowDeleteButton" (click)="fillSelectedForms()">
        <mat-icon>description</mat-icon>Fill Data
      </button>

      <button mat-button color="primary" (click)="downloadSelecetedFile()" *ngIf="ShowDownloadButton">
        <mat-icon>cloud_download</mat-icon> Download
      </button>

      <button mat-button color="primary" (click)="deleteDocuments()" *ngIf="ShowDeleteButton">
        <mat-icon>delete_outline</mat-icon> Delete
      </button>
    </div>
  </mat-card>





  <!-- Filter -->
  <mat-card class="filter">
    <div class="sortview">
      <div class="sortby" *ngIf="showLocalPanel">
        <mat-form-field>
          <mat-label>Sort by</mat-label>
          <mat-select [(ngModel)]="selected">
            <mat-option value="">All</mat-option>
            <mat-option value="">Submit</mat-option>
            <mat-option value="">Under Review</mat-option>
            <mat-option value="">Accepted</mat-option>
            <mat-option value="">Rejected</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="view_list" *ngIf="folderList?.length>0">
        <button mat-icon-button [ngClass]="{ active: list }" mat-icon-button (click)="showList()">
          <mat-icon>format_list_bulleted</mat-icon>
        </button>
        <button mat-icon-button [ngClass]="{ active: grid }" (click)="showGrid()">
          <mat-icon>apps</mat-icon>
        </button>
      </div>
    </div>
    
    <div class="actbtn">
      <button mat-flat-button color="primary" (click)="addFolder(addFolderDialog)">
        Add Folder
      </button>
    </div>
  </mat-card>

  <div Id="document" class="documents" [ngClass]="{ list: list, grid: grid }">
    <mat-accordion cdkDropList [cdkDropListData]="folderList" (cdkDropListDropped)="dropGroup($event)" [multi]="true">

      <ng-container *ngFor="let folder of folderList; let i = index">



        <mat-expansion-panel cdkDropListGroup [expanded]="step === i" cdkDrag [cdkDragData]="folder" disabled="false"
          (click)="togglePanels(i,folder)">
          <mat-expansion-panel-header>
            <mat-panel-title class="header">

              <button class="dragIcon" cdkDragHandle><mat-icon>drag_indicator</mat-icon></button>

              <div class="titleCount">
                <div class="folderName">
                   {{ folder.documentFolderName }}
                  <span class="count">{{ folder.placeholders.length }}</span>
                </div>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="documentcontainer">

            <mat-checkbox class="adddocCheckox" color="primary" (change)="selectAllCheckbox($event, folder)"> 
              Select All
             </mat-checkbox>
          
            <button class="adddoc" (click)="AddPlaceHolder(addNewDoc, folder,i)" mat-button color="primary">
              <mat-icon>add_circle</mat-icon> Add PlaceHolder
            </button>
            
            <div class="upDoc">
              <div class="uploadholder">
                <input #Input type="file" multiple (change)="selectFilesFromDragZone($event,folder)" />
                <div class="textIn">
                  <p>Drag and drop files here </p>
                  <!-- <span class="ml-5 mr-5">or</span>
                <p>click here to browse the files</p> -->
                </div>
              </div>
            </div>

            <div class="stemplate">
              <button mat-icon-button [matMenuTriggerFor]="menu">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu" xPosition="before">
                <button mat-menu-item (click)="renameTemplate(renameFolderNameDialog, folder)">
                  <mat-icon>edit</mat-icon> Rename
                </button>
                <button mat-menu-item *ngIf="folder.placeholders?.length>0"
                  (click)="addTemplate(addTemplateDialog, folder)">
                  <mat-icon>save</mat-icon> Save as Template
                </button>
                <button mat-menu-item (click)="appendTemplate(appendTemplateDialog, folder)">
                  <mat-icon>library_add</mat-icon> Add Template
                </button>
                <button mat-menu-item *ngIf="folder.placeholders?.length>0" (click)="downloadAll(folder.placeholders)">
                  <mat-icon>cloud_download</mat-icon> Download all
                </button>
                <!-- <button mat-menu-item *ngIf="folder.placeholders?.length>0" (click)="fileAccess(access)">
                <mat-icon>admin_panel_settings</mat-icon> Permission
              </button> -->

                <button *ngIf="folder.documentFolderName!='My Folder'" mat-menu-item (click)="removeFolder(folder)">
                  <mat-icon>delete</mat-icon> Remove Folder
                </button>
              </mat-menu>
            </div>

            <div #contenedor class="categories" cdkDropListGroup>

              <ul>
                <li *ngIf="addNewDoc==true && step === i" class="newdoc">
                  <div class="documentList">
                    <form [formGroup]="uploadForm" (ngSubmit)="AddCoreItemForPlaceholder()">
                      <div class="nameadd">
                        <input type="text" class="addname" placeholder="Add Name" maxlength="30"
                          (ngModelChange)="valuechange($event, folder)" [(ngModel)]="documentName"
                          [ngModelOptions]="{ standalone: true }" required />

                        <button class="add" color="primary" mat-icon-button type="submit" [disabled]="uploadFormValue">
                          <mat-icon>save</mat-icon>
                        </button>
                      </div>
                      <div class="uploadholder">
                        <mat-icon>backup</mat-icon>
                        <p *ngIf="selectedFile == ''">Upload document</p>
                        <p *ngIf="selectedFile !== ''">{{ selectedFile }}</p>
                        <span>Drag & Drop here</span>

                        <input #Input type="file" formControlname="uploadDocument"
                          (change)="onFileSelect($event, folder)" />
                      </div>

                    </form>

                    <div class="uplsub">
                      <button mat-button class="upload" [matMenuTriggerFor]="menu" mat-stroked-button
                        color="primary">Select
                        Form/File</button>
                      <mat-menu #menu="matMenu">
                        <button mat-menu-item color="primary" (click)="selectForm(forms,folder,false)">
                          <mat-icon>note_add</mat-icon> Import Form
                        </button>
                        <button mat-menu-item color="primary" (click)="selectDrive(drive,folder)">
                          <mat-icon>add_to_drive</mat-icon> My Drive
                        </button>

                      </mat-menu>
                    </div>

                  </div>
                </li>

                <li *ngIf="folder.placeholders.length==0">
                  <div cdkDropList cdkDropListOrientation="horizontal" id={{folder.documentFolderID}}
                    [cdkDropListData]="{item:undefined,index:0,data:folder.placeholders}"
                    (cdkDropListDropped)="dropItem($event)" [cdkDropListConnectedTo]="getConnectedList()">
                    <!-- <div class="documentList">
                      <div class="nameadd">
                      </div>
                      <div class="uploadholder">
                        <span>Drag & Drop here</span>
                        <input #Input type="file" formControlname="uploadDocument"
                          (change)="onFileSelect($event, folder)" />
                      </div>
                    </div> -->
                  </div>
                </li>

                <ng-container *ngFor="let document of folder.placeholders;let j=index">

                
                <li  cdkDropList cdkDropListOrientation="horizontal" id={{folder.documentFolderID}}
                    [cdkDropListData]="{item:document,index:j,data:folder.placeholders}"
                    (cdkDropListDropped)="dropItem($event)" [cdkDropListConnectedTo]="getConnectedList()" >
                 
                    <div cdkDrag>
                      <!-- if placeholder type ==2 then show form Icon -->
                    <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
                      <div class="documentList"
                        *ngIf="document.placeholderType==2 && document.formType!=2 && document.formType!=3"
                        [ngClass]="document.isRequired === true ? 'css-class-1' : 'css-class-2'"
                        [ngClass]="(document.formID != null && document.formID != 0 && document.placeholderStatus == 4 ) ? 'formcompleted' : '' ">

                        <div class="checkmenu">
                          <mat-checkbox color="primary" [checked]="document.isChecked"
                            (change)="getCheckboxValues($event, document)">
                          </mat-checkbox>
                          
                          <button class="dragIcon" cdkDragHandle><mat-icon>drag_indicator</mat-icon></button>

                          <div class="centerLabel">

                            <div class="firstRow">                  
                            
                            <mat-icon *ngIf="document.isDocumentUploadedToPCC==true" 
                            matTooltip="Uploaded to PointClickCare" style="color: #28A745; margin: 0 11px 0 0; font-size: 20px; line-height: 21px9o; ">sync</mat-icon>
                                                  
                            <div class="">
                              <div class="s-name">{{document.fileCount}}</div>
                            </div>
                            <!-- <span *ngIf="document.formID != null && document.formID != 0 && document.placeholderStatus == 4"
                              class="completedForm">Completed
                             </span> -->
  
                             <!-- <span *ngIf="document.projectID==0 && document.projectStatus==-1"
                              class="declineForm">Project Not Created yet
                             </span> -->
  
                             <span *ngIf="document.projectID>0 && document.projectStatus==0"
                              class="formLabel draftedForm">Draft
                             </span>
  
                             <span *ngIf="document.projectID>0 && document.projectStatus==1"
                              class="formLabel sentForm">Sent
                             </span>
  
                             <span *ngIf="document.projectID>0 && document.projectStatus==2"
                              class="formLabel inprogressForm">In Progress
                             </span>
  
                             <span *ngIf="document.projectID>0 && document.projectStatus==3"
                              class=" formLabel completedForm">Complete
                             </span>
  
                             <span *ngIf="document.projectID>0 && document.projectStatus==4"
                              class="formLabel withDrawForm">Withdraw
                             </span>
  
                             <span *ngIf="document.projectID>0 && document.projectStatus==5"
                              class=" formLabel declineForm">Decline
                             </span>

                            </div>
                            <div class="secondRow">
                            <span class="groupName" *ngIf="document.activeGroup!=null" 
                              matTooltipClass="tooltip" matTooltip="Active Group - {{document.activeGroup}}">
                             {{document.activeGroup}}
                             </span>
                             
                             <span *ngIf="document.isFilled==true"
                              class="formLabel fillForm">Filled
                            </span>
                            
                            </div>

                          </div>

                         

                        
 
                          <button (click)="showDocumentDetail(documentDetail,document)" mat-icon-button>
                            <mat-icon>more_vert</mat-icon>
                          </button>

                        </div>
                        <!-- (click)="openFormProject(document)" -->
                        <div class="typename">
                          <span class="type" *ngIf="document.projectStatus!=3" (click)="showDocumentDetail(documentDetail,document)">
                            <!-- <img src="../../../../../assets/images/icons/formIcon.svg" /> -->
                            <app-doc-icons [iconType]="'FORM'"></app-doc-icons>
                          </span>

                          <span class="type" *ngIf="document.projectID>0 && document.projectStatus==3" (click)="showDocumentDetail(documentDetail,document)">                           
                            <app-doc-icons [iconType]="'PDF'"></app-doc-icons>
                          </span>

                          <span class="name" matTooltipClass="tooltip"
                            matTooltip="{{getplaceholdername(document.placeholderName)}}">
                            {{ getplaceholdername(document.placeholderName) }}
                            <!-- {{ document.placeholderName }} -->
                          </span>

                         
                        </div>
                        <div class="docactions">

                         <button *ngIf="document.projectStatus==0 || document.projectStatus==1" mat-icon-button matTooltip="Fill Data" 
                         (click)="FillSelectForm(document)" [disabled]="document.isFillDisable"
                             matTooltipClass="tooltip">
                          <mat-icon>description</mat-icon>
                        </button>

                          <button *ngIf="document.projectID==0" mat-icon-button matTooltip="Single Sign" (click)="signNow(document.token,document)"
                            matTooltipClass="tooltip">
                            <mat-icon>border_color</mat-icon>
                          </button>
                          <button *ngIf="document.projectID==0" mat-icon-button matTooltip="Create" [disabled]="document.isFillDisable"
                            (click)="addSign(signature,document)" matTooltipClass="tooltip">
                            <mat-icon>auto_fix_high</mat-icon>
                          </button>

                          <button *ngIf="document.projectID>0 && document.projectStatus!=3" mat-icon-button matTooltip="Edit" [disabled]="document.isFillDisable"
                          (click)="addSign(signature,document)" matTooltipClass="tooltip">
                          <mat-icon>format_shapes</mat-icon>
                          </button>


                          <button *ngIf="document.projectID==0" mat-icon-button matTooltip="Replace" [disabled]="document.isFillDisable"
                            (click)="selectForm(forms,document,true)" matTooltipClass="tooltip">
                            <mat-icon>restore_page</mat-icon>
                          </button>

                        </div>
                        <div class="statuslink" *ngIf="document.documentReview ==null">
                          <span class="status submit" matTooltip="Submit" matTooltipClass="tooltip"></span>

                          <button class="subdoc" (click)="addReviewer(addReviewerPopUp,true,false,document)"
                            mat-flat-button color="primary"> Submit </button>
                          <span class="PIlinked">
                            <img src="../../../../../assets/images/icons/docwithpi.svg" alt="" /></span>
                        </div>

                        <!-- UnderReview = 1, Accepted = 2, Rejected = 3, -->
                        <ng-container *ngIf="document.documentReview !=null">
                          <div class="statuslink" *ngIf="document.documentReview.status == 1"
                            (click)="showDocumentDetail(documentDetail,document)">
                            <span class="status review" matTooltip="Under Review" matTooltipClass="tooltip"></span>
                            <span class="PIlinked">
                              <img src="../../../../../assets/images/icons/docwithpi.svg" alt="" /></span>
                          </div>
                          <div class="statuslink" *ngIf="document.documentReview.status == 2"
                            (click)="showDocumentDetail(documentDetail,document)">
                            <span class="status accept" matTooltip="Accepted" matTooltipClass="tooltip"></span>
                            <span class="PIlinked">
                              <img src="../../../../../assets/images/icons/docwithpi.svg" alt="" /></span>
                          </div>
                          <div class="statuslink" *ngIf="document.documentReview.status == 3"
                            (click)="showDocumentDetail(documentDetail,document)">
                            <span class="status reject" matTooltip="Rejected" matTooltipClass="tooltip"></span>
                            <span class="PIlinked">
                              <img src="../../../../../assets/images/icons/docwithpi.svg" alt="" /></span>
                          </div>
                        </ng-container>

                      </div>

                      <div class="documentList"
                        *ngIf="document.placeholderType==0 && document.formType!=2 && document.formType!=3"
                        [ngClass]="document.isRequired === true ? 'css-class-1' : 'css-class-2'">
                        <form [formGroup]="uploadFormPlaceHolder">
                          <div class="checkmenu">
                            <mat-checkbox color="primary" [checked]="document.isChecked"
                              (change)="getCheckboxValues($event, document)">
                            </mat-checkbox>
                            
                            <button class="dragIcon" cdkDragHandle><mat-icon>drag_indicator</mat-icon></button>

                              <mat-icon *ngIf="document.isDocumentUploadedToPCC==true"
                              matTooltip="Uploaded to PointClickCare"  style="color: #28A745;">sync</mat-icon>
                            

                            <button mat-icon-button (click)="showDocumentDetail(documentDetail,document)">
                              <mat-icon>more_vert</mat-icon>
                            </button>
                          </div>
                          <div class="uploadholder">
                            <mat-icon>backup</mat-icon>
                            <p>{{ document.placeholderName }}</p>
                            <span>Drag & Drop here</span>
                            <input #Input type="file" formControlname="uploadDocument"
                              (change)="onFileSelectPlaceHolder($event, folder, document)" />
                          </div>
                          <div class="uplsub">
                            <button mat-button class="upload" [matMenuTriggerFor]="menu" mat-stroked-button
                              color="primary">Select Form/File</button>
                            <mat-menu #menu="matMenu">
                              <button mat-menu-item color="primary" (click)="selectForm(forms,document,false)">
                                <mat-icon>note_add</mat-icon> Import Form
                              </button>
                              <button mat-menu-item color="primary" (click)="selectDrive(drive,document)">
                                <mat-icon>add_to_drive</mat-icon> My Drive
                              </button>
                            </mat-menu>
                          </div>
                        </form>
                      </div>

                      <div class="documentList"
                        *ngIf="document.placeholderType==1 && document.formType!=2 && document.formType!=3"
                        [ngClass]="document.isRequired === true ? 'css-class-1' : 'css-class-2'">

                        <div class="checkmenu">

                          <mat-checkbox color="primary" [checked]="document.isChecked"
                            (change)="getCheckboxValues($event, document)">

                          </mat-checkbox>
                        
                          <button class="dragIcon" cdkDragHandle><mat-icon>drag_indicator</mat-icon></button>

                            <mat-icon  matTooltip="Uploaded to PointClickCare"  *ngIf="document.isDocumentUploadedToPCC==true" style="color: #28A745;">sync</mat-icon>
                          
                          <div class="s-name">{{document.fileCount==0?'':document.fileCount}}</div>
                          <p *ngIf="document.sharedOnPortal==true" matTooltip="Shared On Portal" matTooltipClass="tooltip">
                            <mat-icon>supervised_user_circle</mat-icon>
                          </p>
                          <button (click)="showDocumentDetail(documentDetail,document)" mat-icon-button>
                            <mat-icon>more_vert</mat-icon>
                          </button>
                        </div>
                        <div class="typename" (click)="openDocumentViewer(ViewDocument,document)">
                          <span class="type"
                            *ngIf="fileTypeTolower(document.documentType) == 'pdf' ||fileTypeTolower(document.documentType) == '.pdf'">
                            <!-- <img src="../../../../../assets/icons/fileType/pdf_icon.svg" alt="Pdf File" /> -->
                            <app-doc-icons [iconType]="'PDF'"></app-doc-icons>
                          </span>

                          <span class="type" *ngIf="fileTypeTolower(document.documentType) == 'doc' ||
          fileTypeTolower(document.documentType) == 'docx'">
                            <!-- <img src="../../../../../assets/icons/fileType/doc_icon.svg" alt="Word File" /> -->
                            <app-doc-icons [iconType]="'WORD'"></app-doc-icons>
                          </span>

                          <span class="type" *ngIf="fileTypeTolower(document.documentType) == 'xlsx' ||
          fileTypeTolower(document.documentType) == 'xls' ||
          fileTypeTolower(document.documentType) == 'csv' ||
          fileTypeTolower(document.documentType) == 'ods'">
                            <!-- <img src="../../../../../assets/icons/fileType/excel_icon.svg" alt="excel File" />-->
                            <app-doc-icons [iconType]="'EXCEL'"></app-doc-icons>
                          </span>
                          <span class="type" *ngIf="fileTypeTolower(document.documentType) == 'jpg' ||
          fileTypeTolower(document.documentType) == 'jpeg' || 
          fileTypeTolower(document.documentType) == 'image/jpeg'">
                            <!-- <img src="../../../../../assets/icons/fileType/014-jpg.svg" alt="jpg File" /> -->
                            <app-doc-icons [iconType]="'JPG'"></app-doc-icons>
                          </span>
                          <span class="type" *ngIf="fileTypeTolower(document.documentType) == 'png' ||                  
          fileTypeTolower(document.documentType) == 'tiff' ||
          fileTypeTolower(document.documentType) == 'webp'">
                            <!-- <img src="../../../../../assets/icons/fileType/020-png.svg" alt="png File" /> -->
                            <app-doc-icons [iconType]="'PNG'"></app-doc-icons>
                          </span>

                          <span class="type" *ngIf="fileTypeTolower(document.documentType) == 'gif'">
                            <!-- <img src="../../../../../assets/icons/fileType/012-gif.svg" alt="gif File" /> -->
                            <app-doc-icons [iconType]="'GIF'"></app-doc-icons>
                          </span>

                          <span class="type" *ngIf="fileTypeTolower(document.documentType) == 'bmp'">
                            <!-- <img src="../../../../../assets/icons/fileType/005-bmp.svg" alt="bmp File" /> -->
                            <app-doc-icons [iconType]="'BMP'"></app-doc-icons>
                          </span>

                          <span class="type" *ngIf="document.documentType == 'txt'">
                            <!-- <img src="../../../../../assets/icons/fileType/text_icon.svg" alt="txt File" /> -->
                            <app-doc-icons [iconType]="'TEXT'"></app-doc-icons>
                          </span>
                          <span class="type" *ngIf="document.documentType == 'ppt' ||
              document.documentType == 'pptx'">
                            <!-- <img src="../../../../../assets/icons/fileType/021-ppt.svg" alt="ppt File" /> -->
                            <app-doc-icons [iconType]="'PPT'"></app-doc-icons>
                          </span>
                          <span class="type" *ngIf="document.documentType == null ">
                            <!-- <img src="../../../../../assets/icons/fileType/028-wmv.svg" alt="Word File" /> -->
                            <app-doc-icons [iconType]="'OTHER'"></app-doc-icons>
                          </span>
                          <span class="type" *ngIf="fileTypeTolower(document.documentType) == 'HEIC' ||
        document.documentType == 'heic'">
                            <!-- <img src="../../../../../assets/icons/fileType/021-ppt.svg" alt="ppt File"/> -->
                            <app-doc-icons [iconType]="'HEIC'"></app-doc-icons>
                          </span>
                          <span class="type" *ngIf="
  document.documentType != 'pdf'
  && document.documentType != 'HEIC'
  && document.documentType != 'heic'
        && document.documentType != '.pdf'
        && document.documentType != 'jpg'
        && document.documentType != 'JPG'
        && document.documentType != 'image/jpeg'
        && document.documentType != 'png'
        && document.documentType != 'PNG'
        && document.documentType != 'tiff'
        && document.documentType != 'jpeg'
        && document.documentType != 'gif'
        && document.documentType != 'bmp'


        && document.documentType != 'webp'
        && document.documentType != 'xlsx'
        && document.documentType != 'xls'
        && document.documentType != 'csv'
        && document.documentType != 'ods'        
        
        && document.documentType != 'txt'
        && document.documentType != 'pptx'
        && document.documentType != 'PPT'
        && document.documentType != 'doc'
        && document.documentType != 'docx'        
        
        ">
                            <!-- <img src="../../../../../assets/icons/fileType/028-wmv.svg" alt="Word File" /> -->
                            <app-doc-icons [iconType]="'OTHER'"></app-doc-icons>
                          </span>

                          <span class="name" matTooltipClass="tooltip"
                            matTooltip="{{getplaceholdername(document.placeholderName)}}">
                            {{ getplaceholdername(document.placeholderName) }}
                            <!-- {{ document.placeholderName }} -->
                          </span>
                        </div>
                        <div class="docactions">

                          <mat-spinner style="margin: auto" *ngIf="(document.documentType == 'pdf' || document.documentType == '.pdf') && document.aiProcessStatus==1" diameter="20"></mat-spinner>

                          <button *ngIf="(document.documentType == 'pdf' || document.documentType == '.pdf') && document.aiProcessStatus==0"
                            mat-icon-button matTooltip="Open AI Template" (click)="openAITemplate(document)"
                            matTooltipClass="tooltip">
                            <mat-icon class="notProcessed">restore_page</mat-icon>
                          </button>

                          <button *ngIf="(document.documentType == 'pdf' || document.documentType == '.pdf') && document.aiProcessStatus==2"
                            mat-stroked-button matTooltip="AI Tool" class="globalAiBtn" (click)="showBindingFieldDetail(document)"
                            matTooltipClass="tooltip">
                            AI
                          </button>
                        
                          <button *ngIf="document.documentType == 'pdf' || document.documentType == '.pdf'"
                            mat-icon-button matTooltip="Fill" (click)="FillPlaceholder(document)"
                            matTooltipClass="tooltip">
                            <mat-icon>description</mat-icon>
                          </button>

                          <!-- <button  *ngIf="document.documentType == 'pdf' || document.documentType == '.pdf'
           || document.documentType == 'jpg' || document.documentType == 'image/jpeg' ||
          document.documentType == 'jpeg' || document.documentType == 'png' ||
          document.documentType == 'gif' || document.documentType == 'tiff' ||
          document.documentType == 'webp' || document.documentType == 'bmp'"
          mat-icon-button matTooltip="Fill"  (click)="FillPlaceholder(document)" matTooltipClass="tooltip">                  
           <mat-icon>description</mat-icon>
        </button> -->

                          <!-- <button *ngIf="document.documentType == 'pdf' || document.documentType == '.pdf'
         || document.documentType == 'jpg' || document.documentType == 'image/jpeg' ||
         document.documentType == 'jpeg' || document.documentType == 'png' ||
         document.documentType == 'gif' || document.documentType == 'tiff' ||
         document.documentType == 'webp' || document.documentType == 'bmp'"
         mat-icon-button matTooltip="Quick Sign" [routerLink]="'/request/signature'"  matTooltipClass="tooltip">
        <mat-icon>create</mat-icon>
       </button> -->

                          <input #Input1 hidden="true" type="file" (change)="UploadFile($event,document)" />
                          <button mat-icon-button matTooltip="Upload" (click)="Input.click()" matTooltipClass="tooltip">
                            <mat-icon>cloud_upload</mat-icon>
                          </button>

                          <button mat-icon-button matTooltip="Download" (click)="DownloadSigleFile(document)"
                            matTooltipClass="tooltip">
                            <mat-icon>cloud_download</mat-icon>
                          </button>


                        </div>
                        <div class="statuslink" *ngIf="document.documentReview ==null">
                          <span class="status submit" matTooltip="Submit" matTooltipClass="tooltip"></span>

                          <button class="subdoc" (click)="addReviewer(addReviewerPopUp,true,false,document)"
                            mat-flat-button color="primary"> Submit </button>
                          <span class="PIlinked">
                            <img src="../../../../../assets/images/icons/docwithpi.svg" alt="" /></span>
                        </div>

                        <!-- UnderReview = 1, Accepted = 2, Rejected = 3, -->
                        <ng-container *ngIf="document.documentReview !=null">
                          <div class="statuslink" *ngIf="document.documentReview.status == 1"
                            (click)="showDocumentDetail(documentDetail,document)">
                            <span class="status review" matTooltip="Under Review" matTooltipClass="tooltip"></span>
                            <span class="PIlinked">
                              <img src="../../../../../assets/images/icons/docwithpi.svg" alt="" /></span>
                          </div>
                          <div class="statuslink" *ngIf="document.documentReview.status == 2"
                            (click)="showDocumentDetail(documentDetail,document)">
                            <span class="status accept" matTooltip="Accepted" matTooltipClass="tooltip"></span>
                            <span class="PIlinked">
                              <img src="../../../../../assets/images/icons/docwithpi.svg" alt="" /></span>
                          </div>
                          <div class="statuslink" *ngIf="document.documentReview.status == 3"
                            (click)="showDocumentDetail(documentDetail,document)">
                            <span class="status reject" matTooltip="Rejected" matTooltipClass="tooltip"></span>
                            <span class="PIlinked">
                              <img src="../../../../../assets/images/icons/docwithpi.svg" alt="" /></span>
                          </div>
                        </ng-container>
                      </div>
                      <!-- if FormType ==2 then show tabular Icon -->

                      <div class="documentList" *ngIf="document.formType==2 && document.formType!=3"
                        [ngClass]="document.isRequired === true ? 'css-class-1' : 'css-class-2'">

                        <div class="checkmenu">
                          <mat-checkbox color="primary" [checked]="document.isChecked"
                            (change)="getCheckboxValues($event, document)">
                          </mat-checkbox>

                          <button class="dragIcon" cdkDragHandle><mat-icon>drag_indicator</mat-icon></button>

                          <button (click)="showDocumentDetail(documentDetail,document)" mat-icon-button>
                            <mat-icon>more_vert</mat-icon>
                          </button>

                        </div>
                        <!-- (click)="openFormProject(document)" -->
                        <div class="typename">
                          <span class="type" (click)="showDocumentDetail(documentDetail,document)">
                            <img src="../../../../../assets/images/icons/form_tabuler.svg" />
                          </span>

                          <span class="name" matTooltipClass="tooltip"
                            matTooltip="{{getplaceholdername(document.placeholderName)}}">
                            {{ getplaceholdername(document.placeholderName) }}
                            <!-- {{ document.placeholderName }} -->
                          </span>
                        </div>
                        <div class="docactions">

                          <button mat-icon-button matTooltip="Fill" [disabled]="document.placeholderStatus==4"
                            (click)="TabularSign(document)" matTooltipClass="tooltip">
                            <mat-icon>description</mat-icon>
                          </button>

                          <button *ngIf="document.projectID==0" mat-icon-button matTooltip="Replace" [disabled]="document.placeholderStatus!=1"
                            (click)="selectForm(forms,document,true)" matTooltipClass="tooltip">
                            <mat-icon>restore_page</mat-icon>
                          </button>

                        </div>
                        <div class="statuslink" *ngIf="document.documentReview ==null">
                          <span class="status submit" matTooltip="Submit" matTooltipClass="tooltip"></span>

                          <button class="subdoc" (click)="addReviewer(addReviewerPopUp,true,false,document)"
                            mat-flat-button color="primary"> Submit </button>
                          <span class="PIlinked">
                            <img src="../../../../../assets/images/icons/docwithpi.svg" alt="" /></span>
                        </div>

                        <!-- UnderReview = 1, Accepted = 2, Rejected = 3, -->
                        <ng-container *ngIf="document.documentReview !=null">
                          <div class="statuslink" *ngIf="document.documentReview.status == 1"
                            (click)="showDocumentDetail(documentDetail,document)">
                            <span class="status review" matTooltip="Under Review" matTooltipClass="tooltip"></span>
                            <span class="PIlinked">
                              <img src="../../../../../assets/images/icons/docwithpi.svg" alt="" /></span>
                          </div>
                          <div class="statuslink" *ngIf="document.documentReview.status == 2"
                            (click)="showDocumentDetail(documentDetail,document)">
                            <span class="status accept" matTooltip="Accepted" matTooltipClass="tooltip"></span>
                            <span class="PIlinked">
                              <img src="../../../../../assets/images/icons/docwithpi.svg" alt="" /></span>
                          </div>
                          <div class="statuslink" *ngIf="document.documentReview.status == 3"
                            (click)="showDocumentDetail(documentDetail,document)">
                            <span class="status reject" matTooltip="Rejected" matTooltipClass="tooltip"></span>
                            <span class="PIlinked">
                              <img src="../../../../../assets/images/icons/docwithpi.svg" alt="" /></span>
                          </div>
                        </ng-container>
                      </div>
                      <!-- if FormType ==3 then show HTML Icon -->

                      <div class="documentList" *ngIf="document.placeholderType==2 && document.formType==3"
                        [ngClass]="document.isRequired === true ? 'css-class-1' : 'css-class-2'">

                        <div class="checkmenu">
                          <mat-checkbox color="primary" [checked]="document.isChecked"
                            (change)="getCheckboxValues($event, document)">
                          </mat-checkbox>

                          <button class="dragIcon" cdkDragHandle><mat-icon>drag_indicator</mat-icon></button>
                          
                          <button (click)="showDocumentDetail(documentDetail,document)" mat-icon-button>
                            <mat-icon>more_vert</mat-icon>
                          </button>

                        </div>

                        <div class="typename">
                          <span class="type" (click)="showDocumentDetail(documentDetail,document)">
                            <!-- <img src="../../../../assets/images/icons/form_html.svg" /> -->
                            <app-doc-icons [iconType]="'HTML'"></app-doc-icons>
                          </span>

                          <span class="name" matTooltipClass="tooltip"
                            matTooltip="{{getplaceholdername(document.placeholderName)}}">
                            {{ getplaceholdername(document.placeholderName) }}
                          </span>
                        </div>

                        <div class="docactions">
                          <button mat-icon-button matTooltip="Fill" (click)="HTMLFormSign(document)"
                            matTooltipClass="tooltip">
                            <mat-icon>description</mat-icon>
                          </button>

                          <button mat-icon-button matTooltip="View" (click)="openHtmlData(ViewDocument,document)"
                            matTooltipClass="tooltip">
                            <mat-icon>visibility</mat-icon>
                          </button>

                        </div>


                      </div>
                    </div>
                 
                </li>
                </ng-container>
              </ul>
            </div>
          </div>
        </mat-expansion-panel>

      </ng-container>

    </mat-accordion>
  </div>

</div>


<ng-template #addFolderDialog>
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>description</mat-icon>
    </span>
    Add Folder
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <mat-dialog-content>
    <form [formGroup]="addFolderForm" class="example-form">

      <mat-form-field class="example-full-width mb-5">
        <mat-label>Folder Name</mat-label>
        <input matInput placeholder="Folder Name" maxlength="50" formControlName="folderName" />
      </mat-form-field>

      <mat-form-field>
        <mat-label>Select Template</mat-label>
        <mat-select (selectionChange)="OnSelectTempChange($event)" formControlName="templateID">
          <mat-option *ngFor="let template of templates" [value]="template.templateID">
            {{ template.templateName }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      

    </form>
  </mat-dialog-content>
  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button color="basic" (click)="close()"> Cancel</button>
    <button mat-flat-button color="primary" [disabled]="!addFolderForm.valid"
      (click)="AddCoreDocumentFolder(addFolderForm.value)">
      Add
    </button>
  </mat-dialog-actions>
</ng-template>


<ng-template #addReviewerPopUp>
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>group_add</mat-icon>
    </span>
    Add Reviewer
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <mat-dialog-content class="mat-typography">
    <div class="radOpts">
      <mat-radio-group aria-label="Select an option" color="primary">
        <mat-radio-button value="1" [checked]=true (click)="selectSharedAccessRb(1)">User</mat-radio-button>
        <mat-radio-button value="2" (click)="selectSharedAccessRb(2)">Role</mat-radio-button>
      </mat-radio-group>
    </div>

    <app-contactlist *ngIf="!isSharedAccessRolePopup" [isReviewerPopup]="isReviewerPopup" [objectList]="contactsList"
      [isSharedAccessRolePopup]="isSharedAccessRolePopup" [isRolePopup]="isRolePopup"
      (NotifyItemSelected)="userSelected($event)" (NotifyListfetch)="searchUser($event)"></app-contactlist>
    <app-contactlist *ngIf="isSharedAccessRolePopup" [objectList]="sharedAccessRoleList"
      [isSharedAccessRolePopup]="isSharedAccessRolePopup" [isRolePopup]="isRolePopup"
      (NotifyItemSelected)="RoleSelectedForSharedAccess($event)" (NotifyListfetch)="getSharedAccessRoles($event)">
    </app-contactlist>

    <ul *ngIf="!isSharedAccessRolePopup" class="selectedlist">
      <li *ngFor="let user of peoples">
        <div class="userndetail">
          <div class="detail">
            <h4>{{user.name}}</h4>
            <p>{{user.email}}</p>
          </div>
          <div class="opt">
            <button mat-icon-button>
              <mat-icon (click)="removeItem(user,isRolePopup)">cancel</mat-icon>
            </button>
          </div>
        </div>
      </li>
    </ul>

    <ul *ngIf="isSharedAccessRolePopup" class="selectedlist">
      <li *ngFor="let role of selectedsharedAccessRole">
        <div class="userndetail">
          <div class="detail">
            <h4> {{role.name}}</h4>
          </div>
          <div class="opt">
            <button mat-icon-button>
              <mat-icon (click)="removeItemRoleSharedAccess(role,isSharedAccessRolePopup)">cancel</mat-icon>
            </button>
          </div>
        </div>
      </li>
    </ul>

  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button color="primary" [disabled]=!showAddButton (click)="SubmitReviewer()">Done</button>
  </mat-dialog-actions>
</ng-template>


<ng-template #addTemplateDialog>
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>description</mat-icon>
    </span>
    Save as Template
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <mat-dialog-content>
    <form [formGroup]="addTemplateForm" class="example-form">
      <mat-form-field class="example-full-width">
        <mat-label>Template Name</mat-label>
        <input matInput placeholder="Template Name" maxlength="50" formControlName="templateName" />
      </mat-form-field>

      <div class="publicConvt">
        <span>Make it public</span>
        <mat-slide-toggle color="primary" formControlName="isPublic"></mat-slide-toggle>
      </div>

    </form>
  </mat-dialog-content>
  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button color="basic" (click)="close()"> Cancel</button>
    <button mat-button color="primary" [disabled]="!addTemplateForm.valid"
      (click)="addNewTemplate(addTemplateForm.value)">
      Add
    </button>
  </mat-dialog-actions>
</ng-template>

<ng-template #renameFolderNameDialog>

  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>description</mat-icon>
    </span>
    Rename Folder
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content>
    <form [formGroup]="updateFolderNameForm" class="example-form">
      <mat-form-field class="example-full-width">
        <mat-label>Folder Name</mat-label>
        <input matInput placeholder="Folder Name" maxlength="50" formControlName="folderName" />
      </mat-form-field>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button color="basic" (click)="close()"> Cancel </button>
    <button mat-button color="primary" [disabled]="!updateFolderNameForm.valid"
      (click)="UpdateFolderName(updateFolderNameForm.value)">
      Save
    </button>
  </mat-dialog-actions>
</ng-template>


<ng-template #appendTemplateDialog>
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>description</mat-icon>
    </span>
    Add Template
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <mat-dialog-content>
    <form [formGroup]="appendTemplateForm" class="example-form">
      <mat-form-field>
        <mat-label>Select Template</mat-label>
        <mat-select formControlName="templateID">
          <mat-option *ngFor="let template of templates" [value]="template.templateID">
            {{ template.templateName }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button color="basic" (click)="close()"> Cancel</button>
    <button mat-button color="primary" [disabled]="!appendTemplateForm.valid"
      (click)="appendTemplateInFolder(appendTemplateForm.value)">
      Add
    </button>
  </mat-dialog-actions>
</ng-template>


<ng-template #signature>

  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>group_add</mat-icon>
    </span>
    Select & Add Participants
    <button mat-icon-button (click)="closeSelectParticipant()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">

    <div class="signaturePanel">

      <div class="esign">
        <div class="panel" *ngIf="participantMessageInfo!=null">
          <div class="example-list">
          </div>
          <div class="groupHolder">
            <div cdkDropList class="example-list">
              <div class="groupheading" (click)="getToogleInformation()">
                <h2>
                  <mat-icon>message</mat-icon>Information
                </h2>
                <button mat-icon-button> <mat-icon>expand_more</mat-icon> </button>
              </div>

              <div id="participantMessageDiv" [ngClass]="{'active' : toogleInformation}"
                innerHtml="{{participantMessageInfo}}"></div>

            </div>
          </div>
        </div>
        <div class="panel" cdkDropListGroup>

          <!-- <mat-form-field class="" appearance="fill">
            <mat-label>Project</mat-label>
            <input matInput placeholder="Enter project name" value="">
          </mat-form-field> -->

          <div class="groupHolder" *ngFor="let p1 of projectGroups">

            <div cdkDropList id="{{p1.groupName}}" [cdkDropListData]="p1.projGrpRelationParticipantList"
              class="example-list">

              <div class="groupheading">
                <h2 *ngIf="p1.groupType ==1">
                  <mat-icon>create</mat-icon>{{p1.groupName}}
                </h2>

                <h2 *ngIf="p1.groupType !=1">
                  <mat-icon>description</mat-icon>{{p1.groupName}}
                </h2>

              </div>

              <div *ngIf="p1.projGrpRelationParticipantList.length == 0" class="moveblock example-box">
                <p class="nocontent">No relationship added</p>
              </div>

              <div *ngFor="let p of p1.projGrpRelationParticipantList" class="moveblock example-box" cdkDrag>

                <div class="DragIcon" cdkDragHandle>
                  <mat-icon>drag_indicator</mat-icon>
                </div>

                <div class="Colrd" [ngStyle]="{'background-color': p.colourCode }">
                  <mat-icon *ngIf="p.typeOfParticipant==0">email</mat-icon>
                  <mat-icon *ngIf="p.typeOfParticipant==4">person</mat-icon>
                  <mat-icon *ngIf="p.typeOfParticipant==5">work</mat-icon>
                  <mat-icon *ngIf="p.typeOfParticipant==1">app_registration</mat-icon>
                  <mat-icon *ngIf="p.typeOfParticipant==2">contact_mail</mat-icon>
                  <mat-icon *ngIf="p.typeOfParticipant==3">business</mat-icon>
                </div>

                <div class="userInfo">
                  <div class="chipss">
                    <mat-chip-list>
                      <mat-chip> {{p.relationName}} </mat-chip>
                    </mat-chip-list>
                  </div>


                  <div class="selectContact" *ngIf="p.participantName || p.roleName || p.contactEmail">
                    <div class="userpic" *ngIf="p.participantImageURL">
                      <img [src]="p.participantImageURL" alt="" />
                    </div>

                    <div class="userpic" *ngIf="!p.participantImageURL">
                      <span class="shortName" *ngIf="p.participantName">{{getShortName(p.participantName)}}</span>
                      <span class="shortName" *ngIf="p.roleName">{{getShortName(p.roleName)}}</span>
                      <span class="shortName" *ngIf="p.contactEmail">{{getShortName(p.contactEmail)}}</span>
                    </div>

                    <div class="info">
                      <p *ngIf="p.participantName">{{ p.participantName }} </p>

                      <p *ngIf="p.roleName">{{ p.roleName }} </p>
                      <p *ngIf="p.typeOfParticipant==0">{{p.contactEmail}}</p>
                      <p class="emailID" *ngIf="p.typeOfParticipant!=0">{{ p.participantEmail }} </p>
                    </div>


                    <button class="removeContact" mat-icon-button color="basic" (click)="RemoveRelation(p,p1)">
                      <mat-icon>close</mat-icon>
                    </button>

                  </div>

                  <ng-container *ngIf="!p.participantName && !p.roleName &&  !p.contactEmail">
                    <button mat-icon-button color="primary" class="personadd"
                      (click)="assignUserNew(true,false,'',p,p1)">
                      <mat-icon>person_add</mat-icon>
                    </button>
                    <!-- <button mat-icon-button color="primary" class="personadd"
                      (click)="assignUser(addAssigne,true,false,'',p,p1)">
                      <mat-icon>person_add</mat-icon>
                    </button> -->
                  </ng-container>



                </div>
                 <div class="Cancel">
                  <span class="approver" *ngIf="p.isApprover==true">Approver</span>                  
                </div>

                <ng-container *ngIf="p.selectedContactFieldEmailID.length>1">
                  <div class="partdrop">
                    <mat-form-field>
                      <mat-label>Select {{ContactNames}}</mat-label>
                      <mat-select (selectionChange)="onSelectContact($event,p.relationName,p,p1)">
                        <mat-option *ngFor="let role of p.selectedContactFieldEmailID" [value]="role.name">
                          {{role.name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                </ng-container>

              </div>


            </div>

          </div>

        </div>
      </div>

    </div>

  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button color="basic" (click)="closeSelectParticipant()">Cancel</button>
    <span>
      <button mat-stroked-button color="primary" (click)="openProject()">Edit</button>
      <button mat-flat-button color="primary" [disabled]="!SendButtonDisabled" (click)="ProjectSend()">Send</button>
    </span>
  </mat-dialog-actions>

</ng-template>


<ng-template #relation>
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>group_add</mat-icon>
    </span>
    Add Relations Under Group 1
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">

    <app-contactlist></app-contactlist>

    <ul class="selectedlist">
      <li>
        <div class="userndetail">
          <div class="detail">
            <h4>Doctor</h4>
          </div>
          <div class="opt">
            <button mat-icon-button>
              <mat-icon>cancel</mat-icon>
            </button>
          </div>
        </div>
      </li>
      <li>
        <div class="userndetail">
          <div class="detail">
            <h4>Nurse</h4>
          </div>
          <div class="opt">
            <button mat-icon-button>
              <mat-icon>cancel</mat-icon>
            </button>
          </div>
        </div>
      </li>
    </ul>

  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button color="primary">Done</button>
  </mat-dialog-actions>
</ng-template>


<ng-template #addAssigne>

  <h2 mat-dialog-title *ngIf="isShare">
    <span class="groupIcon">
      <mat-icon>group_add</mat-icon>
    </span>
    Select & Add Participant
    <button mat-icon-button (click)="closeAssign()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <h2 mat-dialog-title *ngIf="!isShare">
    <span class="groupIcon">
      <mat-icon>group_add</mat-icon>
    </span>
    Add Contact
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">
    <div class="radOpts" *ngIf="isShare">
      <mat-radio-group aria-label="Select an option" color="primary">
        <mat-radio-button value="1" [checked]=true (click)="selectSharedAccessRb(1)">{{contactNames}}</mat-radio-button>
        <mat-radio-button value="2" (click)="selectSharedAccessRb(2)">Role</mat-radio-button>
        <mat-radio-button *ngIf="coreNames!=''" value="3" (click)="selectSharedAccessRb(3)">{{coreNames}}</mat-radio-button>
        <mat-radio-button value="4" (click)="selectSharedAccessRb(4)">User</mat-radio-button>
      </mat-radio-group>
    </div>
    <ng-container *ngIf="showContact==true && peoples.length==0">
      <app-contactlist *ngIf="!isSharedAccessRolePopup" [objectList]="contactsList"
        [isSharedAccessRolePopup]="isSharedAccessRolePopup" [isRolePopup]="isRolePopup"
        (NotifyItemSelected)="contactSelected($event)" (NotifyListfetch)="getContactListCoreImplementation($event)"
        (keydown.enter)="onEnter($event)">
      </app-contactlist>
    </ng-container>

    <ng-container *ngIf="showRole==true && selectedsharedAccessRole.length==0">
      <app-contactlist *ngIf="isSharedAccessRolePopup" [objectList]="sharedAccessRoleList"
        [isSharedAccessRolePopup]="isSharedAccessRolePopup" [isRolePopup]="isRolePopup"
        (NotifyItemSelected)="RoleSelectedForSharedAccess($event)" (NotifyListfetch)="getSharedAccessRoles($event)"
        >
      </app-contactlist>
    </ng-container>

    <ng-container *ngIf="showSearchCore==true && selectCoreList.length==0">
      <mat-form-field  appearance="fill">
        <input matInput placeholder="Search {{coreNames}}" [formControl]="stateCtrl"
          (input)="searchCore($event.target.value)" [matAutocomplete]="auto">
          <mat-autocomplete #auto="matAutocomplete">
            <mat-option  (click)="coreSelected(core)" 
             *ngFor="let core of attachedToCoreList" [value]="core.name">
              <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">
                  <div class="userpic">
                      <img *ngIf="core.imageUrl!=''" src="{{core.imageUrl}}" alt="">
                      <span class="username" *ngIf="core.imageUrl==''" class="username">
                          {{core.shortName}}
                        </span>
                  </div>
                  <div class="info">
                    <p> {{ core.name }}</p>
                    <p class="email">{{ core.email }}</p>
                  </div> 
              </span>
            </mat-option>
          </mat-autocomplete>
      </mat-form-field>
    </ng-container>

    <app-contactlist *ngIf="isSharedAccessUserPopup" [objectList]="sharedAccessUserList" [isReviewerPopup]="isSharedAccessUserPopup" [isRolePopup]="isRolePopup" (NotifyItemSelected)="usersSelected($event)" (NotifyListfetch)="getUserListCoreImplementations($event)"></app-contactlist>

    <ul *ngIf="!isSharedAccessRolePopup" class="selectedlist">
      <li *ngFor="let user of peoples">
        <div class="userndetail">
          <div class="userpic">
            <img *ngIf="user.img!=''" src="{{user.img}}" alt="">
            <span *ngIf="user.img==''" class="username">
              {{user.shortName}}
            </span>
          </div>
          <div class="detail">
            <h4>{{user.name}}</h4>
            <p>{{user.email}}</p>
          </div>
          <div class="opt">
            <button mat-icon-button>
              <mat-icon (click)="removeItem(user,isRolePopup)">cancel</mat-icon>
            </button>
          </div>
        </div>
      </li>
    </ul>

    <ul *ngIf="isSharedAccessRolePopup" class="selectedlist">
      <li *ngFor="let role of selectedsharedAccessRole">
        <div class="userndetail">
          <div class="detail">
            <h4> {{role.name}}</h4>
          </div>
          <div class="opt">
            <button mat-icon-button>
              <mat-icon (click)="removeItemRoleParticipant(role,isSharedAccessRolePopup)">cancel</mat-icon>
            </button>
          </div>
        </div>
      </li>
    </ul>

    <ul *ngIf="selectCoreList.length>0" class="selectedlist">
      <li *ngFor="let user of selectCoreList">
        <div class="userndetail">
          <div class="userpic">
            <img *ngIf="user.img!=''" src="{{user.img}}" alt="">
            <span *ngIf="user.img==''" class="username">
              {{user.shortName}}
            </span>
          </div>
          <div class="detail">
            <h4>{{user.name}}</h4>
            <p>{{user.email}}</p>
          </div>
          <div class="opt">
            <button mat-icon-button>
              <mat-icon (click)="removeCore(user)">cancel</mat-icon>
            </button>
          </div>
        </div>
      </li>
    </ul>
    
    <ul *ngIf="userSelectedList.length>0" class="selectedlist">
      <li *ngFor="let user of userSelectedList">
        <div class="userndetail">
            <!-- <div class="userpic">
              <img *ngIf="user.img!=''" src="{{user.img}}" alt="">
              <span *ngIf="user.img==''" class="username">
                  {{user.shortName}}
                </span>
            </div> -->
            <div class="detail">
                <h4>{{user.name}}</h4>
                <p>{{user.email}}</p>
            </div>
            <div class="opt">
                <button mat-icon-button><mat-icon (click)="removeUser(user)">cancel</mat-icon></button>
            </div>
        </div>
      </li>
    </ul>
    
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="closeAssign()">Cancel</button>
    <button mat-flat-button color="primary" [disabled]=!showAddButton (click)="addUpdateParticipants()">Done</button>
  </mat-dialog-actions>
</ng-template>

<ng-template #forms>
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>note_add</mat-icon>
    </span>
    My Forms
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <mat-dialog-content>


    <div class="myforms">
      <div class="drive mainLink">
        <div class="folderName" (click)="GetAllForms()">
          <mat-icon class="type">account_balance</mat-icon>
          Forms
        </div>

        <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
          <mat-tree-node [ngClass]="{ 'active': activeNode === node.formFolderID }" *matTreeNodeDef="let node"
            matTreeNodePadding matTreeNodePaddingIndent="20">
            <div class="folderRow">
              <mat-icon class="mat-icon-rtl-mirror arrowIcon" style="visibility: hidden;">
                arrow_right
              </mat-icon>

              <div class="folderName">
                <mat-icon class="folder" *ngIf="node.isShared == false"
                  (click)="getFormFolderWithTemplatesLeftPanel(node)">folder</mat-icon>
                <mat-icon class="folder" *ngIf="node.isShared == true"
                  (click)="getFormFolderWithTemplatesLeftPanel(node)">folder_shared</mat-icon>
                <span class="flname" (click)="getFormFolderWithTemplatesLeftPanel(node)">{{node.formFolderName}}</span>
              </div>
            </div>
          </mat-tree-node>

          <mat-tree-node [ngClass]="{ 'active': activeNode === node.formFolderID }"
            *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding matTreeNodePaddingIndent="20">
            <div class="folderRow" matTreeNodeToggle [attr.aria-label]="'toggle ' + node.formFolderName">
              <mat-icon class="mat-icon-rtl-mirror arrowIcon">
                {{treeControl.isExpanded(node) ? 'arrow_drop_down' : 'arrow_right'}}
              </mat-icon>
              <div class="folderName">
                <mat-icon class="folder" *ngIf="node.isShared == false"
                  (click)="getFormFolderWithTemplatesLeftPanel(node)">folder</mat-icon>
                <mat-icon class="folder" *ngIf="node.isShared == true"
                  (click)="getFormFolderWithTemplatesLeftPanel(node)">folder_shared</mat-icon>
                <span class="flname" (click)="getFormFolderWithTemplatesLeftPanel(node)">{{node.formFolderName}}</span>
              </div>
            </div>

          </mat-tree-node>
        </mat-tree>

        <div class="folderName" (click)="getSharedWithMe()" [ngClass]="{ 'active': SharedWithMeactive }">
          <mat-icon class="type">portrait</mat-icon> Shared with me
        </div>

      </div>

      <div class="driveDetail" *ngIf="isShowForm">

        <div class="breadcumb">
          <span (click)="breadCrumbMainClick()">Forms</span>
          <span *ngFor="let m of menuHeader;let i= index;">
            <mat-icon class="sidenav-breaddiv">keyboard_arrow_right</mat-icon>
            <a (click)="breadCrumb(menuHeader, i)">{{ m.label }}</a>
          </span>
        </div>

        <mat-card class="files">
          <table class="mat-table">
            <thead>
              <tr class="mat-header-row">
                <th class="mat-header-cell wstar">&nbsp; </th>
                <th class="mat-header-cell wstar"></th>
                <th class="mat-header-cell wstar"></th>
                <th class="mat-header-cell">Name</th>
                <th class="mat-header-cell date">Created On</th>
                <th class="mat-header-cell date">Modified On</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let form of FormFolderListMiddleSection; let i = index;">
                <tr class="mat-row foldericon" (click)="radioChange(form,'MyForm')">
                  <td class="mat-cell wstar">
                    <span class="checkbo" *ngIf="form.type == 2">
                      <mat-radio-button color="primary" value="i" [checked]="form.isChecked"
                        (change)="radioChange(form,'MyForm')"></mat-radio-button>
                    </span>
                  </td>

                  <ng-container *ngIf="getIsFavorite(form) == true; else showFavorite">
                    <td class="mat-cell">
                      <mat-icon class="fav">grade</mat-icon>
                    </td>
                  </ng-container>

                  <ng-template #showFavorite>
                    <td class="mat-cell">
                      <mat-icon class="star">grade</mat-icon>
                    </td>
                  </ng-template>

                  <td class="mat-cell docType" *ngIf="form.type == 1 && form.isShared == false">
                    <mat-icon>folder</mat-icon>
                  </td>

                  <td class="mat-cell docType" *ngIf="form.type == 1 && form.isShared == true">
                    <mat-icon>folder_shared</mat-icon>
                  </td>

                  <td class="mat-cell docType formIcon" *ngIf="form.type == 2 && form.formType==1">
                    <img src="../../../../assets/images/icons/formIcon.svg" alt="" width="28" />
                    <!-- <mat-icon>description</mat-icon> -->
                  </td>

                  <td class="mat-cell docType formIcon" *ngIf="form.type == 2 && form.formType==2">
                    <img src="../../../../assets/images/icons/form_tabuler.svg" alt="" width="28" />
                    <!-- <mat-icon>table_rows</mat-icon> -->
                  </td>

                  <td class="mat-cell docType formIcon" *ngIf="form.type == 2 && form.formType==3">
                    <img src="../../../../assets/images/icons/form_html.svg" alt="" width="28" />
                    <!-- <mat-icon>table_rows</mat-icon> -->
                  </td>

                  <td class="mat-cell" *ngIf="form.type == 1">
                    <span class="formName" matTooltipClass="tooltip" matTooltip="{{form.name}}">{{ form.name }}</span>
                  </td>

                  <td class="mat-cell" *ngIf="form.type == 2">
                    <span class="formName" matTooltipClass="tooltip" matTooltip="{{form.name}}">{{ form.name }}</span>
                  </td>

                  <td class="mat-cell">
                    {{ form.createdOn +'Z'| date: "MM/dd/yyyy" }}
                  </td>

                  <td class="mat-cell" *ngIf="form.updatedOn!=null">
                    {{ form.updatedOn+'Z' | date: "MM/dd/yyyy" }}
                  </td>

                  <td class="mat-cell" *ngIf="form.updatedOn==null">
                    {{ form.createdOn+'Z' | date: "MM/dd/yyyy" }}
                  </td>


                </tr>
              </ng-container>

              <ng-container *ngIf="!FormFolderListMiddleSection">
                <tr>
                  <td colspan="7">
                    <p class="nocontent">No Items Found</p>
                  </td>
                </tr>
              </ng-container>

            </tbody>
          </table>
        </mat-card>
      </div>

      <div class="driveDetail" *ngIf="isSharedWithMe">

        <div class="breadcumb">
          <span (click)="breadCrumbMainSHaredWithMeClick()">Shared with me</span>
          <span *ngFor="let m of menuHeader;let i= index;">
            <mat-icon class="sidenav-breaddiv">keyboard_arrow_right</mat-icon>
            <a (click)="breadCrumb(menuHeader, i)">{{ m.label }}</a>
          </span>
        </div>

        <mat-card class="files">
          <table class="mat-table">
            <thead>
              <tr class="mat-header-row">
                <th class="mat-header-cell wstar">&nbsp; </th>
                <th class="mat-header-cell wstar"></th>
                <th class="mat-header-cell wstar"></th>
                <th class="mat-header-cell">Name</th>
                <th class="mat-header-cell" *ngIf="parentID==0">Shared By</th>
                <th class="mat-header-cell date">Created On</th>
                <th class="mat-header-cell date">Modified On</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let form of SharedWithMeFormFolderList; let i = index;">
                <tr class="mat-row foldericon" (click)="radioChange(form,'SharedWithMe')">
                  <td class="mat-cell wstar">
                    <span class="checkbo" *ngIf="form.type == 2">
                      <mat-radio-button color="primary" value="i" [checked]="form.isChecked"
                        (change)="radioChange(form,'SharedWithMe')"></mat-radio-button>
                    </span>
                  </td>

                  <ng-container *ngIf="getIsFavorite(form) == true; else showFavorite">
                    <td class="mat-cell">
                      <mat-icon class="fav">grade</mat-icon>
                    </td>
                  </ng-container>

                  <ng-template #showFavorite>
                    <td class="mat-cell">
                      <mat-icon class="star">grade</mat-icon>
                    </td>
                  </ng-template>

                  <td class="mat-cell docType" *ngIf="form.type == 1">
                    <mat-icon>folder</mat-icon>
                  </td>

                  <td class="mat-cell docType formIcon" *ngIf="form.type == 2 && form.formType==1">
                    <img src="../../../../assets/images/icons/formIcon.svg" alt="" width="28" />
                    <!-- <mat-icon>description</mat-icon> -->
                  </td>

                  <td class="mat-cell docType formIcon" *ngIf="form.type == 2 && form.formType==2">
                    <!-- <mat-icon>table_rows</mat-icon> -->
                    <img src="../../../../assets/images/icons/form_tabuler.svg" alt="" width="28" />
                  </td>

                  <td class="mat-cell docType formIcon" *ngIf="form.type == 2 && form.formType==3">
                    <!-- <mat-icon>table_rows</mat-icon> -->
                    <img src="../../../../assets/images/icons/form_html.svg" alt="" width="28" />
                  </td>

                  <td class="mat-cell" (click)="getFormFolderWithFormTemplatesSharedWithMe(form)"
                    *ngIf="form.type == 1">
                    <span class="formName" matTooltipClass="tooltip" matTooltip="{{form.name}}">{{ form.name }}</span>
                  </td>

                  <td class="mat-cell" *ngIf="form.type == 2">
                    <span class="formName" matTooltipClass="tooltip" matTooltip="{{form.name}}">{{ form.name }}</span>
                  </td>

                  <td class="mat-cell" *ngIf="parentID==0">
                    <span class="formName" matTooltipClass="tooltip">
                      {{ form.sharedbyFirstName }} {{ form.sharedbyLastName }}
                    </span>
                  </td>

                  <td class="mat-cell" (click)="getFormFolderWithFormTemplatesSharedWithMe(form)"
                    *ngIf="form.type == 1">
                    {{ form.createdOn+'Z' | date: "MM/dd/yyyy" }}
                  </td>

                  <td class="mat-cell" *ngIf="form.type == 2">
                    {{ form.createdOn+'Z' | date: "MM/dd/yyyy" }}
                  </td>

                  <td class="mat-cell" (click)="getFormFolderWithFormTemplatesSharedWithMe(form)"
                    *ngIf="form.type == 1">
                    {{ form.updatedOn+'Z' | date: "MM/dd/yyyy" }}
                  </td>

                  <td class="mat-cell" *ngIf="form.type == 2">
                    {{ form.updatedOn+'Z' | date: "MM/dd/yyyy" }}
                  </td>

                </tr>
              </ng-container>

              <ng-container *ngIf="SharedWithMeFormFolderList.length==0">
                <tr>
                  <td colspan="7">
                    <p class="nocontent">No Items Found</p>
                  </td>
                </tr>
              </ng-container>

            </tbody>
          </table>
        </mat-card>
      </div>

    </div>


  </mat-dialog-content>
  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-stroked-button color="basic" (click)="close()">Cancel</button>
    <button mat-flat-button color="primary" [disabled]="!selectButtonShow" (click)="SelectFormSubmit()">Select</button>
  </mat-dialog-actions>
</ng-template>


<ng-template #drive>
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>note_add</mat-icon>
    </span>
    My Drive
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <mat-dialog-content>

    <div class="myforms">
      <div class="drive mainLink">

        <div class="folderName" (click)="GetAllMyDrive()">
          <mat-icon class="type">account_balance</mat-icon>
          My Drive
        </div>

        <mat-tree [dataSource]="dataSourceFileManager" [treeControl]="treeControlFileManager">
          <mat-tree-node [ngClass]="{ 'active': activeNodeFileManager === node.fileManagerItemID }"
            *matTreeNodeDef="let node" matTreeNodePadding matTreeNodePaddingIndent="20">
            <div class="folderRow">
              <mat-icon class="mat-icon-rtl-mirror arrowIcon" style="visibility: hidden;">
                arrow_right
              </mat-icon>

              <div class="folderName">
                <mat-icon class="folder" *ngIf="node.isShared == false" (click)="showChildFolders(node)">folder
                </mat-icon>
                <mat-icon class="folder" *ngIf="node.isShared == true" (click)="showChildFolders(node)">folder_shared
                </mat-icon>
                <span class="flname" (click)="showChildFolders(node)">{{node.name}}</span>
              </div>
            </div>
          </mat-tree-node>

          <mat-tree-node [ngClass]="{ 'active': activeNodeFileManager === node.fileManagerItemID }"
            *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding matTreeNodePaddingIndent="20">
            <div class="folderRow" matTreeNodeToggle [attr.aria-label]="'toggle ' + node.name">
              <mat-icon class="mat-icon-rtl-mirror arrowIcon">
                {{treeControl.isExpanded(node) ? 'arrow_drop_down' : 'arrow_right'}}
              </mat-icon>
              <div class="folderName">
                <mat-icon class="folder" *ngIf="node.isShared == false" (click)="showChildFolders(node)">folder
                </mat-icon>
                <mat-icon class="folder" *ngIf="node.isShared == true" (click)="showChildFolders(node)">folder_shared
                </mat-icon>
                <span class="flname" (click)="showChildFolders(node)">{{node.name}}</span>
              </div>
            </div>

          </mat-tree-node>
        </mat-tree>

        <div class="folderName" (click)="getSharedWithMeMyDrive()" [ngClass]="{ 'active': SharedWithMeMyDriveactive }">
          <mat-icon class="type">portrait</mat-icon> Shared with me
        </div>

        <!-- <button (click)="loadGoogleDrive()">G-Drive</button> -->




      </div>

      <div class="driveDetail" *ngIf="isShowMyDrive">
        <div class="breadcumb">
          <span (click)="breadCrumbMyDriveMainClick()">My Drive</span>
          <span *ngFor="let m of menuHeaderMyDrive;let i= index;">
            <mat-icon class="sidenav-breaddiv">keyboard_arrow_right</mat-icon>
            <a (click)="breadCrumbMyDrive(menuHeaderMyDrive, i)">{{ m.label }}</a>
          </span>
        </div>

        <mat-card class="files">
          <table class="mat-table">
            <thead>
              <tr class="mat-header-row">
                <th class="mat-header-cell wstar">&nbsp; </th>
                <th class="mat-header-cell wstar"></th>
                <th class="mat-header-cell wstar"></th>
                <th class="mat-header-cell">Name</th>
                <th class="mat-header-cell date">Created On</th>
                <th class="mat-header-cell date">Modified On</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let form of MyDrivefoldersList; let i = index;">
                <tr class="mat-row foldericon" (click)="radioChangeMyDrive(form)">
                  <td class="mat-cell wstar">
                    <span class="checkbo" *ngIf="form.isFile == true">
                      <mat-radio-button color="primary" value="i" [checked]="form.isChecked"
                        (change)="radioChangeMyDrive(form)"></mat-radio-button>
                    </span>
                  </td>

                  <ng-container *ngIf="getIsFavorite(form) == true; else showFavorite">
                    <td class="mat-cell">
                      <mat-icon class="fav">grade</mat-icon>
                    </td>
                  </ng-container>

                  <ng-template #showFavorite>
                    <td class="mat-cell">
                      <mat-icon class="star">grade</mat-icon>
                    </td>
                  </ng-template>

                  <td class="mat-cell docType" *ngIf="form.isFile == false && form.isShared == false">
                    <mat-icon>folder</mat-icon>
                  </td>

                  <td class="mat-cell docType" *ngIf="form.isFile == false && form.isShared == true">
                    <mat-icon>folder_shared</mat-icon>
                  </td>

                  <td class="mat-cell formIcon" *ngIf="form.isFile == true">
                    <ng-container *ngIf="form.fileType == 'pdf'">
                      <img class="fileIcon" src="../../../../../assets/icons/fileType/pdf_icon.svg" alt="Pdf File" />
                    </ng-container>
                    <ng-container *ngIf="form.fileType == 'png'">
                      <img class="fileIcon" src="../../../../../assets/icons/fileType/020-png.svg" alt="png File" />
                    </ng-container>
                    <ng-container *ngIf="form.fileType == 'jpg'">
                      <img class="fileIcon" src="../../../../../assets/icons/fileType/014-jpg.svg" alt="jpg File" />
                    </ng-container>
                    <mat-icon *ngIf="form.fileType != 'pdf' && form.fileType != 'png' && form.fileType != 'jpg'">
                      description
                    </mat-icon>
                  </td>

                  <td class="mat-cell" *ngIf="form.isFile == false">
                    <span class="formName" matTooltipClass="tooltip" matTooltipClass="tooltip"
                      matTooltip="{{form.name}}">{{ form.name }}</span>
                  </td>

                  <td class="mat-cell" *ngIf="form.isFile == true">
                    <span class="formName" matTooltipClass="tooltip" matTooltipClass="tooltip"
                      matTooltip="{{form.name}}">{{ form.name }}</span>
                  </td>

                  <td class="mat-cell">
                    {{ form.createdOn+'Z' | date: "MM/dd/yyyy" }}
                  </td>

                  <td class="mat-cell" *ngIf="form.updatedOn!=null">
                    {{ form.updatedOn+'Z' | date: "MM/dd/yyyy" }}
                  </td>

                  <td class="mat-cell" *ngIf="form.updatedOn==null">
                    {{ form.createdOn+'Z' | date: "MM/dd/yyyy" }}
                  </td>

                </tr>
              </ng-container>

              <ng-container *ngIf="foldersMyDriveListShow">
                <tr>
                  <td colspan="7">
                    <p class="nocontent">No Items Found</p>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </mat-card>
      </div>

      <div class="driveDetail" *ngIf="isSharedWithMeMyDrive">
        <div class="breadcumb">
          <span (click)="breadCrumbMainSHaredWithMeMyDriveClick()">Shared with me</span>
          <span *ngFor="let m of menuHeaderMyDrive;let i= index;">
            <mat-icon class="sidenav-breaddiv">keyboard_arrow_right</mat-icon>
            <a (click)="breadCrumbSharedWithMeMyDrive(menuHeaderMyDrive, i)">{{ m.label }}</a>
          </span>
        </div>

        <mat-card class="files">
          <table class="mat-table">
            <thead>
              <tr class="mat-header-row">
                <th class="mat-header-cell wstar">&nbsp; </th>
                <th class="mat-header-cell wstar"></th>
                <th class="mat-header-cell wstar"></th>
                <th class="mat-header-cell">Name</th>
                <th class="mat-header-cell" *ngIf="parentID==0">Shared By</th>
                <th class="mat-header-cell date">Created On</th>
                <th class="mat-header-cell date">Modified On</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let form of SharedWithMeMyDriveFolderList; let i = index;">
                <tr class="mat-row foldericon" (click)="radioChangeMyDriveSharedWithMe(form)">
                  <td class="mat-cell wstar">
                    <span class="checkbo" *ngIf="form.isFile == true">
                      <mat-radio-button color="primary" value="i" [checked]="form.isChecked"
                        (change)="radioChangeMyDriveSharedWithMe(form)">

                      </mat-radio-button>
                    </span>
                  </td>

                  <ng-container *ngIf="getIsFavorite(form) == true; else showFavorite">
                    <td class="mat-cell">
                      <mat-icon class="fav">grade</mat-icon>
                    </td>
                  </ng-container>

                  <ng-template #showFavorite>
                    <td class="mat-cell">
                      <mat-icon class="star">grade</mat-icon>
                    </td>
                  </ng-template>

                  <td class="mat-cell docType" *ngIf="form.isFile == false">
                    <mat-icon>folder</mat-icon>
                  </td>

                  <td class="mat-cell formIcon" *ngIf="form.isFile == true">
                    <ng-container *ngIf="form.fileType == 'pdf'">
                      <img class="fileIcon" src="../../../../../assets/icons/fileType/pdf_icon.svg" alt="Pdf File" />
                    </ng-container>
                    <ng-container *ngIf="form.fileType == 'png'">
                      <img class="fileIcon" src="../../../../../assets/icons/fileType/020-png.svg" alt="png File" />
                    </ng-container>
                    <ng-container *ngIf="form.fileType == 'jpg'">
                      <img class="fileIcon" src="../../../../../assets/icons/fileType/014-jpg.svg" alt="jpg File" />
                    </ng-container>
                    <mat-icon *ngIf="form.fileType != 'pdf' && form.fileType != 'png' && form.fileType != 'jpg'">
                      description
                    </mat-icon>
                  </td>

                  <td class="mat-cell" *ngIf="form.isFile == false">
                    <span class="formName" matTooltipClass="tooltip" matTooltip="{{form.name}}"
                      (click)="showChildFoldersSharedWithMeMyDrive(form)">{{ form.name }}</span>
                  </td>

                  <td class="mat-cell" *ngIf="form.isFile == true">
                    <span class="formName" matTooltipClass="tooltip" matTooltip="{{form.name}}">{{ form.name }}</span>
                  </td>

                  <td class="mat-cell" *ngIf="parentID==0">
                    <span class="formName" matTooltipClass="tooltip">
                      {{ form.sharedbyFirstName }} {{ form.sharedbyLastName }}
                    </span>
                  </td>

                  <td class="mat-cell">
                    {{ form.createdOn+'Z' | date: "MM/dd/yyyy" }}
                  </td>

                  <td class="mat-cell" *ngIf="form.updatedOn!=null">
                    {{ form.updatedOn+'Z' | date: "MM/dd/yyyy" }}
                  </td>

                  <td class="mat-cell" *ngIf="form.updatedOn==null">
                    {{ form.createdOn+'Z' | date: "MM/dd/yyyy" }}
                  </td>

                </tr>
              </ng-container>

              <ng-container *ngIf="SharedWithMeMyDriveFolderList.length==0">
                <tr>
                  <td colspan="7">
                    <p class="nocontent">No Items Found</p>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </mat-card>
      </div>

    </div>


  </mat-dialog-content>
  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button color="basic" (click)="close()">Cancel</button>
    <button mat-button color="primary" [disabled]="!selectButtonMyDriveShow"
      (click)="AddCoreDocumentfromMyDrive()">Select</button>
  </mat-dialog-actions>
</ng-template>


<ng-template #quickForm>

  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>create</mat-icon>
    </span>
    Select form and add as quick access.
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">


    <div class="searchCreate">
      <mat-form-field class="example-form-field">
        <mat-label>Searh form</mat-label>
        <input matInput type="text">
      </mat-form-field>
      <div class="create">
        <!-- <button mat-stroked-button color="primary">Create Form</button> -->
      </div>
    </div>

    <div class="formList">
      <table class="table">
        <tr>

          <th style="text-align: left;">Template Name</th>
          <th style="text-align: center; width: 100px;">Color</th>
          <th>All Case</th>
          <th style="text-align: center; width: 100px;">Only Case</th>
        </tr>
        <tr>


          <td><label><input name="temp" type="radio"> Registration Form</label></td>
          <td style="text-align: center;">
            <div class="Colrd">
            </div>
          </td>
          <!-- <td>
            <div class="chooseColor">
              <mat-form-field>                 
              <mat-select  (selectionChange)="onChangeColourCode($event,role.controls.transactionalRoleName.value)"
                placeholder="Select Color" formControlName="colourCode">
                <mat-option *ngFor="let code of colourCode" [ngStyle]="{'background-color': code.colourCode}"
                  [value]="code.colourCode">
                  {{ code.colourCode }}
                </mat-option>
              </mat-select>
            </mat-form-field> 
            </div>
          </td> -->

          <td style="text-align: center;"><label><input name="temp1" type="radio"></label></td>
          <td style="text-align: center;"><label><input name="temp1" type="radio"></label></td>
        </tr>

      </table>
    </div>

  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button color="basic">Cancel</button>
    <button mat-flat-button color="primary">Done</button>
  </mat-dialog-actions>

</ng-template>



<ng-template #access>
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>admin_panel_settings</mat-icon>
    </span>
    Folder Permission
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">
    <mat-card class="fileAccess">
      <table class="mat-table">
        <tr class="mat-header-row">
          <th class="mat-header-cell">Role</th>
          <th class="mat-header-cell w100">Read</th>
          <th class="mat-header-cell w100">Write</th>
          <th class="mat-header-cell w100">Delete</th>
        </tr>
        <tr class="mat-row">
          <td class="mat-cell">Admissions</td>
          <td class="mat-cell">
            <mat-checkbox color="primary"></mat-checkbox>
          </td>
          <td class="mat-cell">
            <mat-checkbox color="primary"></mat-checkbox>
          </td>
          <td class="mat-cell">
            <mat-checkbox color="primary"></mat-checkbox>
          </td>
        </tr>
        <tr class="mat-row">
          <td class="mat-cell">Doctor</td>
          <td class="mat-cell">
            <mat-checkbox color="primary"></mat-checkbox>
          </td>
          <td class="mat-cell">
            <mat-checkbox color="primary"></mat-checkbox>
          </td>
          <td class="mat-cell">
            <mat-checkbox color="primary"></mat-checkbox>
          </td>
        </tr>
        <tr class="mat-row">
          <td class="mat-cell">Admin</td>
          <td class="mat-cell">
            <mat-checkbox color="primary"></mat-checkbox>
          </td>
          <td class="mat-cell">
            <mat-checkbox color="primary"></mat-checkbox>
          </td>
          <td class="mat-cell">
            <mat-checkbox color="primary"></mat-checkbox>
          </td>
        </tr>
        <tr class="mat-row">
          <td class="mat-cell">Employer</td>
          <td class="mat-cell">
            <mat-checkbox color="primary"></mat-checkbox>
          </td>
          <td class="mat-cell">
            <mat-checkbox color="primary"></mat-checkbox>
          </td>
          <td class="mat-cell">
            <mat-checkbox color="primary"></mat-checkbox>
          </td>
        </tr>
      </table>
    </mat-card>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button color="primary">Done</button>
  </mat-dialog-actions>
</ng-template>

<ng-template #documentCategory>
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>folder</mat-icon></span>
    Select Document Category
    <button mat-icon-button (click)="close()"><mat-icon>close</mat-icon></button>
  </h2>
  <mat-dialog-content class="mat-typography" style="min-height:80px">
    <mat-form-field>
      <mat-select  placeholder="Select Document Category" [(ngModel)]="selecteddocumentCategory">
        <mat-option *ngFor="let documentCate of documentCategoryList;" [value]="documentCate.id">
          {{documentCate.description}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button color="primary" (click)="UploadDocumenttoPCC()">
      Upload
    </button>

  </mat-dialog-actions>
</ng-template>


<ng-template #extract>
  <h2 mat-dialog-title>
    AI Field Mapping
    <button mat-icon-button (click)="close()"><mat-icon>close</mat-icon></button>
  </h2>
  <mat-dialog-content class="mat-typography">
    <mat-card class="fileAccess">
      <table class="mat-table">
        <tr class="mat-header-row">
          <th class="mat-header-cell">Form Fields</th>
          <th class="mat-header-cell w100">System Fields</th>
          <th class="mat-header-cell w100">AI</th>
          <th class="mat-header-cell w100">Value</th>
        </tr>
        <tr class="mat-row" *ngFor="let item of ExtractDocument">
          <td class="mat-cell">{{item.key}}</td>
          <td class="mat-cell">
            <mat-form-field>
              <mat-label>Choose fields</mat-label>
              <mat-select  class="custom-select-style">               
                <mat-option *ngFor="let pro of Feildproperty" [value]="pro.fieldID">
                {{ pro.fieldName }}
                </mat-option>
              </mat-select>
            </mat-form-field>

          </td>
          <td class="mat-cell"><mat-icon>account_circle</mat-icon></td>
          <td class="mat-cell">{{item.value}}</td>
        </tr>
      
      </table>
    </mat-card>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="close()">Cancel</button>
    <div class="">
      <button mat-stroked-button color="primary" (click)="close()">Map Fields</button>
    <button mat-flat-button color="primary" (click)="close()">Finish</button>
    </div>

  </mat-dialog-actions>
</ng-template>

<!-- <app-fax-File [mainModuleName]="mainModuleNameFileManager"
[ngClass]="{ open: showSharefexFile }"
(closeShareFile)="getCloseShareFile($event)">
</app-fax-File> -->




<app-loader></app-loader>